/**
 * 选人选部门公共组件基础版 方法部分
 */

 import {
  NomalDataModal,
  TransferUserDeptDataChildrenModal,
} from '@cloud/atom-ui/lib/transfer-user-dept/interface/interface';
import SelectPersonUrl from '@src/configs/web.config';

const deptTransferIterm = (item, language, ifSelectDept) => {
  return {
    title: language === 'en' && item.deptNameEn !== null ? item.deptNameEn : item.deptNameCn,
    key: `${item.deptCode}`,
    isLeaf: false,
    leafType: 'dept',
    parentKey: [{ key: item.fatherCode, title: '' }],
    iconType: 'AmuFolderOutlined',
    selectable: ifSelectDept,
  } as NomalDataModal;
};
const token = window.document.cookie.match(/X-XSRF-TOKEN=([^;]+)?/)
const unionPath = '/wecode/service/system/scope-api-transmission'
const getparentKey = (deptInfo, deptCode) => {
  if (deptInfo.length === 0 && deptCode !== null) {
    // 在不分域且无权限的情况下补入默认
    return [{ key: deptCode, tittle: '' }];
  }
  return deptInfo.map((item) => ({ key: item.deptCode, title: item.deptNameCn }));
};

const userTransferIterm = (item, language, deptcode) => {
  return {
    title: language === 'en' && item.personNameEn !== null ? item.personNameEn : item.personNameCn,
    key: `${item.personAccount}`,
    isLeaf: true,
    leafType: 'user',
    parentKey: getparentKey(item.deptInfo, deptcode),
    iconType: 'AmuStaffOutlined',
  } as NomalDataModal;
};

const getrUserDeptData = (deptCode, itemUser, itemDept, language, ifSelectDept) => {
  const tmpList = [];
  if (itemDept.code === '0') {
    if (itemDept.data[0].deptCode == '0') {
      itemDept.data.splice(0, 1);
      itemDept.pagination.total--;
    }
    tmpList.push({
      TypeKey: 'dept',
      total: itemDept.pagination.total,
      pageIndex: 1,
      data: itemDept.data.map((item) => deptTransferIterm(item, language, ifSelectDept)),
    });
  }
  if (itemUser.code === '0') {
    tmpList.push({
      TypeKey: 'user',
      total: itemUser.pagination.total,
      pageIndex: 1,
      data: itemUser.data.map((item) => userTransferIterm(item, language, deptCode)),
    });
  }
  return tmpList as TransferUserDeptDataChildrenModal[];
};

export const getTransferData = (deptCode, title, itemDept, itemUser, language, ifSelectDept) => {
  if (itemUser.code === '0' || itemDept.code === '0') {
    const total =
      (itemUser.code === '0' ? itemUser.pagination.total : 0) +
      (itemDept.code === '0' && ifSelectDept ? itemDept.pagination.total : 0);
    const groupType = [];
    if (itemDept.code === '0') {
      groupType.push({ label: language === 'en' ? 'Dept' : '部门', leafType: 'dept' });
    }
    if (itemUser.code === '0') {
      groupType.push({ label: language === 'en' ? 'User' : '人员', leafType: 'user' });
    }
    return {
      total,
      title: title,
      key: `${deptCode}`,
      leafType: 'dept',
      groupType,
      children: getrUserDeptData(deptCode, itemUser, itemDept, language, ifSelectDept),
    };
  }
  return {
    total: 0,
    title: title,
    key: `${deptCode}`,
    leafType: 'dept',
    groupType: [],
    children: [],
  };
};

const roleTransferIterm = (item, isLeaf) => {
  return {
    title: item.roleName,
    key: `${item.roleId}`,
    isLeaf,
    leafType: 'role',
    parentKey: [
      {
        key: item.roleFather == '0' ? '角色' : item.roleFather,
        title: item.roleFather,
      },
    ],
    iconType: 'TeamOutlined',
  } as NomalDataModal;
};

const getRoleData = (itemRole) => {
  return [
    {
      TypeKey: 'role',
      total: itemRole.data.length,
      pageIndex: 1,
      data: itemRole.data.map((item) => {
        let tmpData = roleTransferIterm(item.roleGroup, false);
        tmpData.selectable = false;
        return tmpData;
      }),
    },
  ] as TransferUserDeptDataChildrenModal[];
};

export const getRoleTransferData = (key, title, itemRole) => {
  return {
    fatherData: {
      total: itemRole.data.length,
      title: title,
      key: `角色`,
      leafType: 'role',
      groupType: [{ label: '角色', leafType: 'role' }],
      children: getRoleData(itemRole),
      selectAllAble: false,
    },
    childrenData: itemRole.data.map((item) => {
      return {
        total: item.roleGroup.personCount,
        title: item.roleGroup.roleName,
        key: `${item.roleGroup.roleId}`,
        leafType: 'role',
        groupType: [{ label: '角色', leafType: 'role' }],
        children: [
          {
            TypeKey: 'role',
            total: item.roleGroup.personCount,
            pageIndex: 1,
            data: item.roles.map((childitem) => roleTransferIterm(childitem, true)),
          },
        ],
      };
    }),
  };
};

export const fetchDeptUserData = (code, pageIndex, pageSize, type, ifReal = true, noPermission = false) => {
  if (!ifReal) {
    return new Promise((resolve) => resolve({ code: -1 }));
  }
  const judgUrl = () => {
    let tmpUrl = '';
    if (type === 'user') {
      tmpUrl = noPermission
        ? SelectPersonUrl.selectPersonUrl.usersNoPermission
        : SelectPersonUrl.selectPersonUrl.users;
      return `${tmpUrl}/${code}/${'users'}`;
    }
    if (type === 'dept') {
      tmpUrl = noPermission
        ? SelectPersonUrl.selectPersonUrl.departmentsNoPermission
        : SelectPersonUrl.selectPersonUrl.departments;
      return `${tmpUrl}/${code}/${'childDepartments'}`;
    }
  };
  const judgBody = (pageSize) => {
    return {
      method: 'GET',
      path: `${judgUrl()}?pageSize=${pageSize}&pageIndex=${pageIndex}`,
      body: {
        deptCode: code,
        isRecursive: false
      },
    }
  }
  const requre = (pageSize) => {
    return fetch(unionPath, {
      method: 'POST',
      //@ts-ignore
      body: judgBody(pageSize)
    });
  };
  // 全选逻辑 多次查询获取所有数据
  if (pageSize === 'all') {
    let resData = [];
    return new Promise((resolve, reject) => {
      requre(120)
        .then((reply: any) => {
          resData.push(...reply.data);
          let pages = reply.pagination.pages;
          if (pages > 10) {
            reject('toManyToSelect');
          } else {
            let PromiseList = [];
            for (let index = 2; index <= pages; index++) {
              PromiseList.push(fetchDeptUserData(code, index, 120, type, ifReal, noPermission));
            }
            Promise.all(PromiseList).then((tmpdata) => {
              tmpdata.forEach((item: any) => {
                resData.push(...item.data);
              });
              reply.data = resData;
              resolve(reply);
            });
          }
        })
        .catch((error) => reject(error));
    });
  } else {
    return new Promise((resolve, reject) => {
      requre(pageSize)
        .then((reply) => resolve(reply))
        .catch((error) => reject(error));
    });
  }
};

export const fetchRolesData = () => {
  return new Promise((resolve, reject) => {
    let url = `${SelectPersonUrl.selectPersonUrl.roleLIst}`;
    fetch(unionPath, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: "post",
      body: {
        //@ts-ignore
        method: 'get',
        path: url,
      }
    })
      .then((reply: any) => {
        if (reply.code !== '0') {
          reply.data = [];
        }
        resolve(reply);
      })
      .catch((error) => reject(error));
  });
};

export const searchDeptUsersByWord = (searchWord, pageIndex, pageSize, type, ifReal = true, noPermission = false) => {
  const name = searchWord ? searchWord.replace(/\s+/g,"") : '';
  return new Promise((resolve, reject) => {
    if (ifReal) {
      let url = ``;
      let body = {};
      let tmpUserUrl = noPermission
        ? SelectPersonUrl.selectPersonUrl.searchUserNopermission
        : SelectPersonUrl.selectPersonUrl.searchUser;
      let tmpDeptUrl = noPermission
        ? SelectPersonUrl.selectPersonUrl.searchDeptNopermisson
        : SelectPersonUrl.selectPersonUrl.searchDept;
      switch (type) {
        case 'dept':
          url = `${tmpDeptUrl}?deptName=${name}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
          body = {
            method: 'get',
            path:url,
          }
          break;
        case 'user':
          url = `${tmpUserUrl}?userName=${name}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
          body = {
            method: 'get',
            path:url,
          }
          break;
        case 'role':
          url = `${SelectPersonUrl.selectPersonUrl.searchRole}?roleName=${name}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
          body = {
            method: 'get',
            path:url,
          }
          break;
        default:
          break;
      }
      fetch(unionPath, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: "post",
        //@ts-ignore
        body:body
      })
        .then((reply) => resolve(reply))
        .catch((error) => reject(error));
    } else {
      resolve({
        pagination: {
          total: 0,
        },
        data: [],
      });
    }
  });
};

export const transferDeptSearchData = (searchRes, pageIndex, language, ifSelectDept) => {
  if (searchRes.data === undefined || searchRes.pagination === undefined) {
    return { total: 0 };
  }
  let res = {
    TypeKey: language === 'en' ? 'Dept' : '部门',
    total: searchRes.pagination && searchRes.pagination.total,
    pageIndex,
    data: searchRes.data.map((item) => deptTransferIterm(item, language, ifSelectDept)),
  };
  return res;
};

export const transferUserSearchData = (searchRes, pageIndex, language) => {
  if (searchRes.data === undefined || searchRes.pagination === undefined) {
    return { total: 0 };
  }
  let res = {
    TypeKey: language === 'en' ? 'User' : '人员',
    total: searchRes.pagination && searchRes.pagination.total,
    pageIndex,
    data: searchRes.data.map((item) => {
      let tmpData = userTransferIterm(item, language, null);
      if (item.deptInfo !== undefined && item.deptInfo.length > 0) {
        tmpData.title = handleUserSearchResultTitle(tmpData.title, language, item.deptInfo);
      }
      return tmpData;
    }),
  };
  return res;
};

export const transferRolepSearchData = (searchRes, pageIndex, language) => {
  if (searchRes.data === undefined || searchRes.pagination === undefined) {
    return { total: 0 };
  }
  let res = {
    TypeKey: language === 'en' ? 'Role' : '角色',
    total: searchRes.pagination && searchRes.pagination.total,
    pageIndex,
    data: searchRes.data.map((item) => roleTransferIterm(item, true)),
  };
  return res;
};

export const toLoadMoreData = (res, type, language, ifSelectDept) => {
  switch (type) {
    case 'dept':
      return res.data.map((item) => deptTransferIterm(item, language, ifSelectDept));
    case 'user':
      return res.data.map((item) => userTransferIterm(item, language, null));
    case 'userSearch':
      return res.data.map((item) => {
        let tmpData = userTransferIterm(item, language, null);
        if (item.deptInfo !== undefined && item.deptInfo.length > 0) {
          tmpData.title = handleUserSearchResultTitle(tmpData.title, language, item.deptInfo);
        }
        return tmpData;
      });
    case 'role':
      return res.data.map((item) => roleTransferIterm(item, true));
    default:
      break;
  }
};

export const judgType = (type, iconFlag) => {
  let typeKey = '';
  let iconKey = '';
  switch (type) {
    case '人员':
      typeKey = 'user';
      iconKey = 'AmuStaffOutlined';
      break;
    case '部门':
      typeKey = 'dept';
      iconKey = 'AmuFolderOutlined';
      break;
    case '角色':
      typeKey = 'role';
      iconKey = 'TeamOutlined';
      break;
    case 'user':
      typeKey = '人员';
      iconKey = 'AmuStaffOutlined';
      break;
    case 'dept':
      typeKey = '部门';
      iconKey = 'AmuFolderOutlined';
      break;
    case 'role':
      typeKey = '角色';
      iconKey = 'TeamOutlined';
      break;
    default:
      typeKey = 'user';
      iconKey = 'AmuStaffOutlined';
      break;
  }
  return iconFlag ? iconKey : typeKey;
};

export const handleAllSelfOnly = (res) => {
  if (res.children[0] !== undefined) {
    res.children[0].data.forEach((item) => {
      if (item.leafType === 'dept') {
        item.selfOnly = true;
      }
    });
  }
};

const handleUserSearchResultTitle = (title, language, deptInfo) => {
  let deptNameList = '';
  let nameArray = [];
  if (language === 'en') {
    for (let dept of deptInfo) {
      nameArray.push(dept.deptNameEn);
    }
  } else {
    for (let dept of deptInfo) {
      nameArray.push(dept.deptNameCn);
    }
  }
  deptNameList = nameArray.join(',\u00A0');
  return `${title} (\u00A0${deptNameList}\u00A0)`;
};
